export enum CharacterFlag {
    None = 0,
    IgnoreWorkOrders = 1 << 0,
}
